import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer id="footer">
        <div className="container">
          <div className="row pt-5 pb-5">
            <div className="col-md-3">
              <h5 className="my-h5-head">About us</h5>
              <p className="footer-about">
                There are many variations of lorem spassages of Lorem Ipsum
                available internet tend to repeat predefined.
              </p>
              <a href="/" className="footer-logo">
                Chez Pix Marketing
              </a>
            </div>

            <div className="col-md-3">
              <h5 className="my-h5-head">Mission</h5>
              <p className="footer-about">
                There are many variations of lorem spassages of Lorem Ipsum
                available internet tend to repeat predefined.
              </p>
            </div>

            <div className="col-md-3">
              <h5 className="my-h5-head">Important Links</h5>
              <ul className="footer-links-list">
                <li>
                  <a className="footer-link" href="#">
                    Home
                  </a>
                </li>
                <li>
                  <a className="footer-link" href="#">
                    About us
                  </a>
                </li>
                <li>
                  <a className="footer-link" href="#">
                    Our Services
                  </a>
                </li>
                <li>
                  <a className="footer-link" href="#">
                    Our Industries
                  </a>
                </li>
                <li>
                  <a className="footer-link" href="#">
                    Contact us
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-md-3">
              <h5 className="my-h5-head">Get In Touch</h5>
              <ul className="footer-links-list">
                <li className="footer-contact-link">
                  <i className="fa fa-map-marker" aria-hidden="true" />
                  121 King St, Melbourne VIC 3000, Australia
                </li>
                <li className="footer-contact-link">
                  <i className="fa fa-envelope-o" aria-hidden="true" />
                  info@example.com
                </li>
                <li className="footer-contact-link">
                  <i className="fa fa-phone" aria-hidden="true" /> 888-123-4587
                </li>
              </ul>
            </div>
          </div>
          <div className="row mt-4 copyright-row">
            <div className="col-12 text-center">
              <p className="pt-3 copyright">
                Development By{" "}
                <a className="text-white" href="#">
                  MoroSoft
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
